import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { Input, Typography } from 'antd'
import { StateStoredValue } from '../hooks/StoreHooks'
import * as con from "../Constants"
import { RefLanguage } from '../hooks/LanguageHooks'
import { isNullOrUndefinedOrBlank } from '../utils/generalFunctions'
import { setStoredValue } from '../store/actions'
import { processAndSetFinalInputSequence, resetUploadedFileInputSequence } from '../store/sequencesActions'

const { TextArea } = Input;
const { Text } = Typography;

// Outside to avoid rerendering
const processInputSequence = async (inputSequence) => {

    if (isNullOrUndefinedOrBlank(inputSequence)) {
        setStoredValue(con.INPUT_TEXT_SEQUENCE_STATUS, con.STATUS_IS_MISSING)
        return
    }
    let status = await processAndSetFinalInputSequence(inputSequence, con.TEXT_INPUT)
    if (status === con.STATUS_OK)
        resetUploadedFileInputSequence()

}

function SequenceInput() {

    // Store the input sequence
    const [inputSequence, setInputSequence] = StateStoredValue(con.INPUT_TEXT_SEQUENCE)

    const i18n = RefLanguage()
    const textAreaRef = useRef(null);
    const debounceTimeout = useRef(null);

    const cursorPositionRef = useRef(null);
    const scrollPositionRef = useRef({ left: 0, top: 0 });

    const handleSequenceChange = (e) => {

        // TODO
        // Put input if it is a massive text

        // Store cursor and scroll positions for restoration after re-render
        cursorPositionRef.current = e.target.selectionStart;
        scrollPositionRef.current = { left: e.target.scrollLeft, top: e.target.scrollTop };

        if (e.target.value !== inputSequence) {
            setInputSequence(e.target.value)
        }
    }



    // Use Effect global handler for input text sequence status and message.
    // Runs once user stops typing
    useEffect(() => {

        // Sets to editing
        setStoredValue(con.INPUT_TEXT_SEQUENCE_STATUS, con.STATUS_PROCESSING)


        // Clear previous timeout
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        // Set new timeout
        debounceTimeout.current = setTimeout(() => {
            processInputSequence(inputSequence)
        }, 750); // 750ms debounce delay

        return () => clearTimeout(debounceTimeout.current); // cleanup on unmount or re-run


    }, [inputSequence])



    useLayoutEffect(() => {

        const pos = cursorPositionRef.current;

        if (pos != null && textAreaRef.current) {
            const element = textAreaRef.current instanceof HTMLTextAreaElement
                ? textAreaRef.current
                : textAreaRef.current.resizableTextArea?.textArea || textAreaRef.current;

            if (element && typeof element.setSelectionRange === 'function') {
                element.focus();
                element.setSelectionRange(pos, pos);

                // Restore scroll position
                element.scrollLeft = scrollPositionRef.current.left;
                element.scrollTop = scrollPositionRef.current.top;

            }

            // Clear the stored cursor and scroll positions
            cursorPositionRef.current = null;
            scrollPositionRef.current = { left: 0, top: 0 };
        }


    }, [inputSequence]);




    return (
        <div data-tour="sequence-input">
            <Typography style={{ marginBottom: "1vh" }}>
                <Text style={{ fontSize: "var(--command-text-size)", fontWeight: "bold" }}>{i18n.t("sequenceInput")}</Text>
            </Typography>
            <TextArea
                ref={textAreaRef}
                value={inputSequence}
                onChange={handleSequenceChange}
                placeholder={i18n.t("enterFastaSequenceHere")}
                autoSize={{ minRows: 9, maxRows: 18 }}
                style={{ marginBottom: "2vh", whiteSpace: "nowrap" }}
            />
        </div>
    )
}

export default SequenceInput
